<div class="dialog">
    <h6 class="text-center">Reason for Rejection</h6>

    <div class="content mt-2">

        <div class="row">
            <mat-radio-button (change)="radioChange($event)" value="0" class="col-md-4" color="warn"><span class="label">Capacity Full</span></mat-radio-button>
            <mat-radio-button (change)="radioChange($event)" value="1" class="col-md-4" color="warn"><span class="label">Rate Discrepancy</span></mat-radio-button>
            <mat-radio-button (change)="radioChange($event)" value="2" class="col-md-4" color="warn"><span class="label">Material Shortage</span></mat-radio-button>
        </div>
        <div class="row mt-2">
            <mat-radio-button (change)="radioChange($event)" value="3" class="col-md-4" color="warn"><span class="label">Technical Difficulties</span></mat-radio-button>
            <mat-radio-button (change)="radioChange($event)" value="4" class="col-md-4" color="warn"><span class="label">Order out of Scope</span></mat-radio-button>
            <mat-radio-button (change)="radioChange($event)" value="5" class="col-md-4" color="warn"><span class="label">Not Interested</span></mat-radio-button>
        </div>
        <div class="row mt-2">
            <mat-radio-button (change)="radioChange($event)" value="6" class="col-md-4" color="warn"><span class="label">Other</span></mat-radio-button>
        </div>

        <div class="input custom-form mt-2">
            <input type="text" value="" (keyup)="inputField($event.target.value)" [disabled]="otherReasons">
        </div>
        <div class="row button mt-3">
            <button class="grey mr-2" (click)="close()">Cancel</button>
            <button class="orange ml-2" (click)="submit()">Confirm</button>
        </div>

    </div>

</div>